import "./App.css";
import React from "react";
import { BrowserRouter as Router, Route, Routes, BrowserRouter } from "react-router-dom";
import Home from "./components/Home/Home/Home";
import Login from "./components/Login/Login";
import AuthProvider from "./contexts/AuthProvider";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import Register from "./components/Register/Register";
import BookProducts from "./components/BookProducts/BookProducts";
import DashboardPage from "./components/Dashboard/DashboardPage/DashboardPage";
import Explore from "./components/Explore/Explore";
import MakeAdmin from "./components/Dashboard/MakeAdmin/MakeAdmin";
import MyBooking from "./components/Dashboard/MyBooking/MyBooking";
import Payment from "./components/Dashboard/Payment/Payment";
import Review from "./components/Dashboard/Review/Review";
import AddProduct from "./components/Dashboard/AddProduct/AddProduct";
import ManageOrder from "./components/Dashboard/ManageOrder/ManageOrder";
import ManageProducts from "./components/Dashboard/ManageProducts/ManageProducts";
import DashboardHome from "./components/Dashboard/DashboardHome/DashboardHome";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/products/:productId"
              element={
                <PrivateRoute>
                  <BookProducts />
                </PrivateRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="makeAdmin" element={<MakeAdmin />} />
              <Route path="myBooking" element={<MyBooking />} />
              <Route path="payment" element={<Payment />} />
              <Route path="review" element={<Review />} />
              <Route path="manageProducts" element={<ManageProducts />} />
              <Route path="addProduct" element={<AddProduct />} />
              <Route path="manageOrder" element={<ManageOrder />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
